import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import Header from "@/components/feature/Header";
import Footer from "@/components/feature/Footer";

export default function SpreadsheetGuide() {
  const { t } = useTranslation();

  return (
    <>
      <Header />

      <main>
        <article className="mx-auto max-w-3xl px-4 py-12 md:px-6 md:py-16">
          {/* Breadcrumb */}
          <nav className="mb-6 flex items-center gap-2 text-sm text-foreground-500">
            <Link to="/" className="text-foreground-600 hover:text-primary-600 transition-colors cursor-pointer">
              {t("nav.home")}
            </Link>
            <span className="flex h-4 w-4 items-center justify-center">
              <i className="ri-arrow-right-s-line text-sm"></i>
            </span>
            <span className="text-foreground-400">{t("nav.guide")}</span>
          </nav>

          <h1 className="text-3xl font-bold leading-tight text-foreground-900 md:text-4xl">
            {t("article.title")}
          </h1>

          <div className="mt-4 flex items-center gap-3 text-xs text-foreground-500">
            <span className="inline-flex items-center gap-1.5">
              <span className="flex h-4 w-4 items-center justify-center">
                <i className="ri-calendar-line text-xs"></i>
              </span>
              {t("article.published")}
            </span>
            <span className="inline-flex items-center gap-1.5">
              <span className="flex h-4 w-4 items-center justify-center">
                <i className="ri-global-line text-xs"></i>
              </span>
              AllChinaBuy Spreadsheet
            </span>
          </div>

          <div className="mt-6 overflow-hidden rounded-lg">
            <img
              src="https://readdy.ai/api/search-image?query=Clean%20organized%20spreadsheet%20concept%20with%20fashion%20products%20sneakers%20hoodies%20and%20caps%20floating%20around%20a%20minimal%20light%20background%2C%20soft%20sage%20green%20and%20cream%20tones%2C%20modern%20European%20editorial%20style%2C%20airy%20and%20bright%20composition&width=1200&height=600&seq=allchina-article-2026&orientation=landscape"
              alt="AllChinaBuy spreadsheet guide"
              title="AllChinaBuy spreadsheet guide"
              className="h-full w-full object-cover object-top"
            />
          </div>

          <p className="mt-8 text-base leading-relaxed text-foreground-700 md:text-lg">
            {t("article.intro")}
          </p>

          <h2 className="mt-10 text-2xl font-bold text-foreground-900">
            {t("article.h2.what")}
          </h2>
          <p className="mt-4 text-base leading-relaxed text-foreground-700">
            {t("article.p.what")}
          </p>

          <h2 className="mt-10 text-2xl font-bold text-foreground-900">
            {t("article.h2.categories")}
          </h2>
          <p className="mt-4 text-base leading-relaxed text-foreground-700">
            {t("article.p.categories")}
          </p>

          <h2 className="mt-10 text-2xl font-bold text-foreground-900">
            {t("article.h2.howto")}
          </h2>
          <p className="mt-4 text-base leading-relaxed text-foreground-700">
            {t("article.p.howto")}
          </p>

          <h2 className="mt-10 text-2xl font-bold text-foreground-900">
            {t("article.h2.safety")}
          </h2>
          <p className="mt-4 text-base leading-relaxed text-foreground-700">
            {t("article.p.safety")}
          </p>

          <div className="mt-10 rounded-lg border border-background-200 bg-background-100 p-6">
            <p className="text-base leading-relaxed text-foreground-700">
              {t("article.conclusion")}
            </p>
            <Link
              to="/"
              className="mt-5 inline-flex items-center justify-center whitespace-nowrap rounded-md bg-primary-500 px-6 py-3 text-sm font-semibold text-background-50 cursor-pointer transition-colors hover:bg-primary-600"
            >
              <span className="mr-2 flex h-5 w-5 items-center justify-center">
                <i className="ri-arrow-left-line text-base"></i>
              </span>
              {t("article.cta")}
            </Link>
          </div>
        </article>
      </main>

      <Footer />
    </>
  );
}